import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { useUpsertAppParam } from "src/api/client-api/appParams";
import { FoodsSelect, themes } from "@foodpilot/foods";

type ThemeProps = {
    currentTheme: string | null;
};
export const Theme = (props: ThemeProps) => {
    const { currentTheme } = props;
    const upsertAppParam = useUpsertAppParam();
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            <Box sx={{ display: "flex", flexDirection: "row", height: "75px", gap: "16px" }}>
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <Typography variant="big-bold">{`Theme`}</Typography>
                    <FoodsSelect
                        selectedOption={currentTheme}
                        options={Object.keys(themes)}
                        onChange={(selectedItem) => {
                            if (selectedItem === null) return;
                            upsertAppParam.mutate({
                                isNew: currentTheme === null ? true : false,
                                key: "theme",
                                value: selectedItem,
                            });
                        }}
                        getId={(item) => item}
                        getName={(item) => item}
                        textOptions={{
                            placeholder: t("component.select.placeholder"),
                            searchPlaceholder: t("component.select.searchplaceholder"),
                            emptyOptionsText: t("component.select.nooptions"),
                            defaultValueText: t("component.select.defaultvalue"),
                            noResult: t("component.select.noresultfound"),
                        }}
                    />
                </Box>
            </Box>

            {/* <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                <Typography variant="body-bold">Thème Personnalisé</Typography>
                <Button
                    variant="outlined"
                    onClick={() => navigate("/settings/custom-theme")}
                    sx={{ alignSelf: "flex-start" }}
                >
                    🎨 Créer un thème personnalisé
                </Button>
                <Typography variant="small" color="text.secondary">
                    Créez votre propre thème avec des couleurs et logos personnalisés
                </Typography>
            </Box> */}
        </Box>
    );
};
